export default {
    validateEmail: (email) => {
        let emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*\.\w+$/;
        return emailRegex.test(email);
      },
    validateCPF: (cpf) => {
        var cpfInvalidos = [
          "00000000000",
          "11111111111",
          "22222222222",
          "33333333333",
          "44444444444",
          "55555555555",
          "66666666666",
          "77777777777",
          "88888888888",
          "99999999999"
        ];
    
        var cpf = cpf.replace(/[^\d]+/g, "");
        if (cpf == "") return false;
        if (cpf.length != 11) return false;
        if (cpfInvalidos.includes(cpf)) return false;
    
        var add = 0;
        for (let i = 0; i < 9; i++) add += parseInt(cpf.charAt(i)) * (10 - i);
        var rev = 11 - (add % 11);
        if (rev == 10 || rev == 11) rev = 0;
        if (rev != parseInt(cpf.charAt(9))) return false;
        // Valida 2o digito
        add = 0;
        for (let i = 0; i < 10; i++) add += parseInt(cpf.charAt(i)) * (11 - i);
        rev = 11 - (add % 11);
        if (rev == 10 || rev == 11) rev = 0;
        if (rev != parseInt(cpf.charAt(10))) return false;
    
        return true;
      }
};


// WEBPACK FOOTER //
// ./src/util/validators.js